import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { ThemeNav, ThemeNavActive } from "../Theme";

const TableContent = ({ text, number, dotcolor, numcolor, valueId, isValue }) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const handleNavigate = () => {
        if (isValue != true) {
            history.push(`/journal`, { src: location.pathname, valueId: valueId })
        }
    }

    return (
        <div className={`${isValue == true ? "" : "cursor-pointer"} ${"flex flex-row py-1 items-center"}`}
            onClick={() => handleNavigate()}>
            <p className="text-sm">{text}</p>
            {number > 0 ?
                <ThemeNavActive className={`text-${numcolor} text-xs rounded-full h-5 w-5 flex 
                            items-center justify-center absolute right-5`}>
                    {number}
                </ThemeNavActive> :
                <ThemeNav className={`bg-${dotcolor} text-${numcolor} text-xs rounded-full h-5 w-5 flex 
            items-center justify-center absolute right-5`}>
                    {number}
                </ThemeNav>
            }
        </div>

    )
}

TableContent.propTypes = {
    text: PropTypes.string,
    number: PropTypes.number,
    dotcolor: PropTypes.string,
    numcolor: PropTypes.string,
}

export default TableContent